// frontend/components/sidebar/SideViewPanel.tsx

"use client";

import { ArrowUpRight, X } from "lucide-react";

interface SideViewPanelProps {
  docId: string;
  onClose: () => void;
}

export default function SideViewPanel({ docId, onClose }: SideViewPanelProps) {
  return (
    <div className="h-full flex flex-col bg-white dark:bg-[#191919]">
      {/* 헤더 */}
      <div className="flex items-center justify-between px-3 py-2 border-b border-gray-200 dark:border-zinc-800 shrink-0">
        <button
          onClick={() => window.open(`/doc/${docId}`, "_blank")}
          title="새 탭에서 열기"
          className="p-1.5 rounded hover:bg-gray-100 dark:hover:bg-zinc-800 text-gray-400 dark:text-zinc-400 hover:text-gray-600 dark:hover:text-zinc-200 transition-colors"
        >
          <ArrowUpRight size={15} />
        </button>
        <button
          onClick={onClose}
          title="닫기"
          className="p-1.5 rounded hover:bg-gray-100 dark:hover:bg-zinc-800 text-gray-400 dark:text-zinc-400 hover:text-gray-600 dark:hover:text-zinc-200 transition-colors"
        >
          <X size={15} />
        </button>
      </div>

      {/* 문서 iframe */}
      <iframe
        src={`/doc/${docId}?embed=1`}
        className="flex-1 w-full border-0"
        title="사이드 보기"
      />
    </div>
  );
}
